class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header');
    this.mainDetailsToggle = this.querySelector('.mega-menu');
    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onFocusOut.bind(this));

    const submenu = this.mainDetailsToggle.querySelector('.mega-menu__content')

    if (submenu) {
      submenu.addEventListener('mouseenter', this.open.bind(this));
      submenu.addEventListener('mouseleave', this.onFocusOut.bind(this));
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', "");
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    // Add class to header when mega-menu opens
    if (this.header) {
      this.header.classList.add('mega-menu-open');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    // Remove class from header when mega-menu closes
    if (this.header) {
      this.header.classList.remove('mega-menu-open');
    }
  }
  
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class AccountDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('.header__icon');
    this.mainDetailsToggle.addEventListener('click', this.onToggle.bind(this));
  }
  onToggle() {
    if (this.mainDetailsToggle.classList.contains('active')) {
      this.mainDetailsToggle.classList.remove('active')
    } else {
      this.mainDetailsToggle.classList.add('active')
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('account-drawer', AccountDrawer);